<template>
    <div class="boxs-page">
        <PageHeader title="产品展示" subtitle="沃雷顿自行车专业解决方案" :breadcrumbItems="[{ text: '首页', path: '/' }]"
            currentText="产品展示" />

        <!-- 降级数据提示 -->
        <!-- <el-alert
            v-if="isFallback"
            :title="errorMessage"
            type="info"
            :closable="false"
            center
            show-icon
            style="margin-bottom: 20px;"
        /> -->


        <div class="page-container">
            <!-- 左侧筛选 -->
            <section class="featured-type" v-if="isShowType">
                <el-affix :offset="100" target=".featured-type">
                    <div class="demo-collapse">
                        <el-collapse v-model="activeNames" @change="handleChange">
                            <el-collapse-item name="1">
                                <template #title><span class="title">产品类型</span></template>
                                <div class="type-product">
                                    <el-radio-group v-model="ptype" @change="queryData">
                                        <el-radio :value="cate.id" size="large" v-for="cate in pconfig.categoryList">{{
                                            cate.name || '' }}</el-radio>
                                    </el-radio-group>
                                </div>

                            </el-collapse-item>
                            <el-collapse-item name="2">
                                <template #title><span class="title">产品颜色</span></template>
                                <div class="type-color">
                                    <button class="filter-item is--color  is--button" v-for="sku in pconfig.colorList"
                                        @click="checkColor(sku.id, true)">
                                        <div class="filter-item__color-patch" :style="{ background: sku.color }">
                                            <div class="icon-checkmark" :class="{ 'is--selected': pcolor === sku.id }">
                                                <el-icon><Select /></el-icon>
                                            </div>
                                            <img v-if="sku.cover" width="100%" height="100%" :src="sku.cover" alt="">
                                        </div>
                                        <span class="filter-item__item-label"
                                            :class="{ 'is--selected': pcolor === sku.id }">{{ sku.label || '-'
                                            }}</span>
                                    </button>
                                </div>
                            </el-collapse-item>
                            <el-collapse-item name="3">
                                <template #title><span class="title">尺码</span></template>
                                <div class="type-size">
                                    <button class="filter-item is--size  is--button"
                                        :class="{ 'is--selected': psize === size.id }" v-for="size in pconfig.sizeList"
                                        @click="checkSize(size.id, true)">
                                        <span class="filter-item__item-label"
                                            :class="{ 'is--selected': psize === size.id }">{{ size.label || '-'
                                            }}</span>
                                    </button>
                                </div>

                            </el-collapse-item>
                            <el-collapse-item name="4">
                                <template #title><span class="title">按价格选购</span></template>
                                <div class="type-product">
                                    <el-radio-group v-model="pprice" @click="checkPrice(true)">
                                        <el-radio :value="item.id" size="large" v-for="item in pconfig.priceList">{{
                                            item.label }}</el-radio>
                                    </el-radio-group>
                                </div>

                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </el-affix>
            </section>
            <!-- 手机筛选 -->
            <el-drawer v-model="typeDrawer" direction="btt" size="100%" class="featured-mobile">
                <template #header>
                    <h2 style="margin: 0;">筛选条件</h2>
                </template>
                <template #default>
                    <div class="demo-collapse">
                        <el-collapse v-model="activeNames" @change="handleChange">
                            <el-collapse-item name="0">
                                <template #title><span class="title">排序依据</span></template>
                                <div class="type-product">
                                    <el-radio-group v-model="psort">
                                        <el-radio :value="item.id" size="large" @click="selectSort(item)"
                                            v-for="item in sortMap">{{ item.title
                                            }}</el-radio>
                                    </el-radio-group>
                                </div>
                            </el-collapse-item>
                            <el-collapse-item name="1">
                                <template #title><span class="title">产品类型</span></template>
                                <div class="type-product">
                                    <el-radio-group v-model="ptype">
                                        <el-radio :value="cate.id" size="large" v-for="cate in pconfig.categoryList">{{
                                            cate.name ||
                                            '' }}</el-radio>
                                    </el-radio-group>
                                </div>

                            </el-collapse-item>
                            <el-collapse-item name="2">
                                <template #title><span class="title">产品颜色</span></template>
                                <div class="type-color">
                                    <button class="filter-item is--color  is--button" v-for="sku in pconfig.colorList"
                                        @click="checkColor(sku.id)">
                                        <div class="filter-item__color-patch" :style="{ background: sku.color }">
                                            <div class="icon-checkmark" :class="{ 'is--selected': pcolor === sku.id }">
                                                <el-icon><Select /></el-icon>
                                            </div>
                                            <img v-if="sku.cover" width="100%" height="100%" :src="sku.cover" alt="">
                                        </div>
                                        <span class="filter-item__item-label"
                                            :class="{ 'is--selected': pcolor === sku.id }">{{ sku.label || '-'
                                            }}</span>
                                    </button>
                                </div>
                            </el-collapse-item>
                            <el-collapse-item name="3">
                                <template #title><span class="title">尺码</span></template>
                                <div class="type-size">
                                    <button class="filter-item is--size  is--button"
                                        :class="{ 'is--selected': psize === size.id }" v-for="size in pconfig.sizeList"
                                        @click="checkSize(size.id)">
                                        <span class="filter-item__item-label"
                                            :class="{ 'is--selected': psize === size.id }">{{ size.label ||
                                                '-'
                                            }}</span>
                                    </button>
                                </div>

                            </el-collapse-item>
                            <el-collapse-item name="4">
                                <template #title><span class="title">按价格选购</span></template>
                                <div class="type-product">
                                    <el-radio-group v-model="pprice" @input="checkPrice(false)">
                                        <el-radio :value="item.id" size="large" v-for="item in pconfig.priceList">{{
                                            item.label }}</el-radio>
                                    </el-radio-group>
                                </div>

                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </template>
                <template #footer>
                    <div class="section-mobile">
                        <div class="section-btn" style="width:100%;margin-right: 32px;" @click="confirmClick">筛选</div>
                        <div class="section-btn" style="width:100%" @click="cancelClick">清除</div>
                    </div>
                </template>
            </el-drawer>
            <!-- 热门业务 -->
            <section class="featured-section">
                <div class="section-header">
                    <div class="section-mobile">
                        <div style="">
                            <h2 class="section-title">自行车</h2>
                        </div>
                        <div class="section-btn" @click="typeDrawer = true">
                            <span style="color: black;">{{ isShowType ? '隐藏' : '显示' }}筛选条件</span>
                            <svg style="color: black;" aria-hidden="true" class="icon-filter-ds" focusable="false"
                                viewBox="0 0 24 24" role="img" width="24px" height="24px" fill="none">
                                <path stroke="currentColor" stroke-width="1.5" d="M21 8.25H10m-5.25 0H3"></path>
                                <path stroke="currentColor" stroke-width="1.5"
                                    d="M7.5 6v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" clip-rule="evenodd">
                                </path>
                                <path stroke="currentColor" stroke-width="1.5" d="M3 15.75h10.75m5 0H21"></path>
                                <path stroke="currentColor" stroke-width="1.5"
                                    d="M16.5 13.5v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" clip-rule="evenodd">
                                </path>
                            </svg>
                        </div>
                    </div>
                    <el-menu background-color="#FFF" mode="horizontal" :ellipsis="false" class="section-menu">
                        <el-menu-item index="0">
                            <template #title>
                                <h2 class="section-title">{{ pconfig.cateName || '' }}</h2>
                            </template>
                        </el-menu-item>
                        <el-menu-item index="1" @click="showOrHideChange">
                            <template #title>
                                <span style="color: black;">{{ isShowType ? '隐藏' : '显示' }}筛选条件</span>
                                <svg style="color: black;" aria-hidden="true" class="icon-filter-ds" focusable="false"
                                    viewBox="0 0 24 24" role="img" width="24px" height="24px" fill="none">
                                    <path stroke="currentColor" stroke-width="1.5" d="M21 8.25H10m-5.25 0H3"></path>
                                    <path stroke="currentColor" stroke-width="1.5"
                                        d="M7.5 6v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" clip-rule="evenodd">
                                    </path>
                                    <path stroke="currentColor" stroke-width="1.5" d="M3 15.75h10.75m5 0H21"></path>
                                    <path stroke="currentColor" stroke-width="1.5"
                                        d="M16.5 13.5v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" clip-rule="evenodd">
                                    </path>
                                </svg>
                            </template>
                        </el-menu-item>
                        <el-sub-menu index="2">
                            <template #title>
                                <span style="color: black;">排序依据：</span>
                                <span style="color: rgb(112, 112, 114);">{{ currSort.title }}</span>
                            </template>
                            <el-menu-item :index="item.id" v-for="item in sortMap" @click="selectSort(item)">{{
                                item.title
                                }}</el-menu-item>
                        </el-sub-menu>
                    </el-menu>
                </div>

                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :md="8" v-for="item in topProductList" :key="item.id"
                        style=" margin-bottom: 32px;">
                        <div class="featured-card" @click="handleChangepage(item.id)">
                            <div class="card-image">
                                <img
                                    :src="item.coverImage ? item.coverImage : require('@/assets/images/home/cart1.png')" />
                                <div class="card-category">{{ item.categoryName?.split(',').pop() || '未分类' }}</div>
                            </div>
                            <div class="card-content">
                                <h3 class="card-title">{{ item.spuName }}</h3>
                                <div class="card-meta"> {{ item.spuDesc }} </div>
                                <div class="price">￥{{ item.retailPrice || 0 }}</div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <!-- 空状态 -->
                <el-empty v-if="!loading && topProductList.length === 0" description="暂无相关产品" />
            </section>

        </div>

        <!-- 回到顶部按钮 -->
        <el-backtop :visibility-height="100" />
    </div>
</template>

<script setup>
import { Search } from '@element-plus/icons-vue';
import { ref, onMounted, computed ,watch} from 'vue';
import moment from 'moment';
import axios from 'axios';
import _ from 'lodash';
import { useRouter, useRoute } from 'vue-router';
import PageHeader from '@/components/PageHeader.vue';
import { getProductList, getProductConfig } from '@/api/product';

const route = useRoute();
moment.locale("zh-cn");
const searchText = ref("");
const visible = ref(false);
const productList = ref([]);
const loading = ref(true);
const isFallback = ref(false);
const errorMessage = ref('');

const isShowType = ref(true);

const showOrHideChange = () => {
    isShowType.value = !isShowType.value;
}

// 左边筛选
const whichTab = ref(1);
const psort = ref(0);
const ptype = ref(0);
const pprice = ref(0);
const previousPrice = ref(0);
const pcolor = ref(0);
const psize = ref(0);

const activeNames = ref(['0', '1', '2', '3', '4'])
const handleChange = (val) => {
    console.log(val)
}

const checkColor = (id, find = false) => {
    if (id == pcolor.value) pcolor.value = 0;
    else pcolor.value = id;
    if (find)
        queryData();
}

const checkSize = (id, find = false) => {
    if (id == psize.value) psize.value = 0;
    else psize.value = id;
    if (find)
        queryData();
}

const checkPrice = (find = false) => {
    setTimeout(() => {
        if (pprice.value === previousPrice.value) {
            pprice.value = 0; // 如果相同，清空选择
        } else {
            previousPrice.value = pprice.value; // 更新上次选中的值
            pprice.value = pprice.value;
        }
        if (find)
            queryData();
    }, 200)

}



const colorList = [
    { "id": 2, "label": "唐三彩", "cover": "https://cdn.xidesheng.com/2025/03/31/1743406194723-PSn1737164275934-ZAWtangsancai.png" },
    { "id": 3, "label": "环湖蓝", "cover": " https://cdn.xidesheng.com/2025/04/15/1744683351930-zmx1744683182934.jpg" },
    { "id": 4, "label": "黑武士", "cover": " https://cdn.xidesheng.com/2025/03/31/1743406320470-E0w1737164246852-Cfkheiwushi.png" },
    { "id": 5, "label": "大溪地", "cover": " https://cdn.xidesheng.com/2025/03/31/1743406324377-vhS1737164253581-AhIdaxidi.png" },
    { "id": 6, "label": "云中君", "cover": " https://cdn.xidesheng.com/2025/03/31/1743406327967-WIB1737164261965-Jf7yunzhongjun.png" },
    { "id": 7, "label": "千山翠", "cover": " https://cdn.xidesheng.com/2025/03/31/1743406331711-iHq1737164272306-z1Wqianshancui.png" },
    { "id": 8, "label": "科幻银", "cover": " https://cdn.xidesheng.com/2025/03/31/1743406352480-sSd1737164313283-9HIkehuanyin.png" },
    { "id": 9, "label": "阿斯塔纳", "cover": " https://cdn.xidesheng.com/2025/03/31/1743406367339-pMR1741397691212-WlIastn.png" },
    { "id": 10, "label": "环意粉", "cover": "https://cdn.xidesheng.com/2025/05/18/1747536980948-8ZB%E7%8E%AF%E6%84%8F%E7%BA%AA%E5%BF%B5.png" },
    { "id": 11, "label": "非洲冠军版", "cover": "https://cdn.xidesheng.com/2025/05/27/1748308919034-4nL1748308628617.jpg" },
    { "id": 12, "label": "意大利冠军版", "cover": "https://cdn.xidesheng.com/2025/06/03/1748911294341-Lbn%E6%84%8F%E5%A4%A7%E5%88%A9.png" },
    { "id": 13, "label": "环意蓝", "cover": "https://cdn.xidesheng.com/2025/06/17/1750141795119-ciB%E7%8E%AF%E6%84%8F%E8%93%9D.png" }
]

const sizeList = [
    { "id": 1, "label": "XS" },
    { "id": 2, "label": "S" },
    { "id": 3, "label": "M" },
    { "id": 4, "label": "L" },
    { "id": 5, "label": "XL" }
]

const priceList = [
    { "id": 1, "label": "1000-3000" },
    { "id": 2, "label": "3000-5000" },
    { "id": 3, "label": "5000-10000" },
    { "id": 4, "label": "10000-30000" },
    { "id": 5, "label": "30000-100000" }
]

const pconfig = ref({
    colorList: [],
    sizeList: [],
    priceList: [],
    categoryList: [],
    cateName: ''
})


// 降级数据 - 当API请求失败时使用
const fallbackBoxes = [
    {
        "id": "1925466587907633153",
        "spuName": "Vorlad AD9 阿斯塔纳非洲冠军版",
        "spuDesc": "【形象店专属】流动的纪念碑，承载着非洲冠军的辉煌与精神",
        "coverImage": "https://cdn.xidesheng.com/2025/08/23/1755919557760-7pE%E9%9D%9E%E6%B4%B2%E5%86%A0%E5%86%9B%E7%89%88-%E6%AD%A3%E5%BC%8F%E5%9B%BE(1).png",
        "productDetailShow": 1,
        "retailPrice": 62178.00,
    },
    {
        "id": "1929701543911501825",
        "spuName": "Vorlad AD9 阿斯塔纳意大利冠军版",
        "spuDesc": "【形象店专属】荣耀风中舞动，意式荣耀的流线雕塑",
        "coverImage": "https://cdn.xidesheng.com/2025/06/03/1748911641487-vmA%E6%84%8F%E5%A4%A7%E5%88%A9%E5%86%A0%E5%86%9B%E7%89%88%20%E5%8F%B3.136.png",
        "productDetailShow": 1,
        "retailPrice": 62178.00,
    },
    {
        "id": "1934864974331392002",
        "spuName": "Vorlad AD9 爬坡王纪念版",
        "spuDesc": "纪念 沃雷顿 ASTANA 车队获得25环意爬坡积分榜冠军",
        "coverImage": "https://cdn.xidesheng.com/2025/06/17/1750148863384-yYM%E7%8E%AF%E6%84%8F%E8%93%9D%20.157.png",
        "productDetailShow": 1,
        "retailPrice": 57178.00,
    },
    {
        "id": "1923940102482833410",
        "spuName": "Vorlad AD9 环意纪念版",
        "spuDesc": "【限时】纪念 沃雷顿 ASTANA 车队获得环意S8总成绩第一",
        "coverImage": "https://cdn.xidesheng.com/2025/05/18/1747543933897-Ep3%E6%AD%A3.png",
        "productDetailShow": 1,
        "retailPrice": 57178.00,
    },
    {
        "id": "1880059951851864065",
        "spuName": "Vorlad RS8",
        "spuDesc": "R7170 Di2 12S BRANTA UL45",
        "coverImage": "https://cdn.xidesheng.com/2025/03/24/1742800788168-nQqTSC105%20ul.webp",
        "productDetailShow": 1,
        "retailPrice": 21980.00,
    },
    {
        "id": "1891777277617856514",
        "spuName": "Vorlad RS9",
        "spuDesc": "R9270 Di2 12S VISION 45 SL",
        "coverImage": "https://cdn.xidesheng.com/2025/03/24/1742800664468-OLFRS9%20HEIWUSHI-DA-VISION-1200x700px.webp",
        "productDetailShow": 1,
        "retailPrice": 49980.00,
    },
    {
        "id": "1880431832845111297",
        "spuName": "Vorlad AD8",
        "spuDesc": "R7170 Di2 12S BRANTA UL50",
        "coverImage": "https://cdn.xidesheng.com/2025/03/24/1742800852041-qCKHWS105%20ul(1)~1.webp",
        "productDetailShow": 1,
        "retailPrice": 23980.00,
    },
    {
        "id": "1895768468945317889",
        "spuName": "Vorlad AD9",
        "spuDesc": "R9270 Di2 12S VISION 60 SL",
        "coverImage": "https://cdn.xidesheng.com/2025/03/24/1742800548185-MVB1742363703113-Ufd1741331711333-CbHAD9MG_1476.webp",
        "productDetailShow": 1,
        "retailPrice": 51980.00,
    },
    {
        "id": "1898184934290329602",
        "spuName": "Vorlad DB01",
        "spuDesc": "R9270 DI2 12S VISION METORN SL",
        "coverImage": "https://cdn.xidesheng.com/2025/08/14/1755131840302-OkH%E9%98%BF%E6%96%AF%E5%A1%94%E7%BA%B3tt%E6%AD%A3%E7%A1%AE%E9%85%8D%E7%BD%AE.webp",
        "productDetailShow": 1,
        "retailPrice": 108000.00,
    },
    {
        "id": "1950019323193892866",
        "spuName": "Vorlad AD8车架组",
        "spuDesc": "车架组包含 碳纤维一体把 碳纤维超轻座管",
        "coverImage": "https://cdn.xidesheng.com/2025/07/30/1753842275903-2Tm%E5%A4%A7%E6%BA%AA%E5%9C%B0.29.png",
        "productDetailShow": 1,
        "retailPrice": 12980.00,
    },
    {
        "id": "1957649914563338242",
        "spuName": "Vorlad AD9车架组",
        "spuDesc": "车架组包含 碳纤维一体把 碳纤维超轻座管",
        "coverImage": "https://cdn.xidesheng.com/2025/08/19/1755574976484-PpE%E9%BB%91%E6%AD%A6%E5%A3%AB.25.png",
        "productDetailShow": 1,
        "retailPrice": 19800.00,
    },
    {
        "id": "1892028958670675970",
        "spuName": "Vorlad RS8车架组",
        "spuDesc": "车架组包含 碳纤维一体把 碳纤维超轻座管",
        "coverImage": "https://cdn.xidesheng.com/2025/03/24/1742802095067-I3hrs89.webp",
        "productDetailShow": 1,
        "retailPrice": 10980.00,
    }
];



// 排序数据
const sortMap = [
    { id: '2-1', 'title': '精选推荐', 'field': 'sort', 'sort': 'desc' },
    { id: '2-2', 'title': '最新', 'field': 'create_time', 'sort': 'desc' },
    { id: '2-3', 'title': '价格：由高到低', 'field': 'price', 'sort': 'desc' },
    { id: '2-4', 'title': '价格：由低到高', 'field': 'price', 'sort': 'asc' }
];
const currSort = ref(sortMap[0])
psort.value = currSort.value.id;

function selectSort(item) {
    currSort.value = item;
    queryData();
}


const typeDrawer = ref(false);
function cancelClick() {
    pcolor.value = 0;
    pprice.value = 0;
    psize.value = 0;
    currSort.value = sortMap[0];
    psort.value = currSort.value.id;
}

function confirmClick() {
    typeDrawer.value = false
    queryData()
}

async function loadConfig(id) {
    try {
        loading.value = true;
        const res = await getProductConfig(id);
        pconfig.value = res.data;

    } catch (error) {
        console.error('获取失败:', error);
        pconfig.value.colorList = colorList;
        pconfig.value.sizeList = sizeList;
        pconfig.value.priceList = priceList;
    } finally {

    }
}

async function queryData() {
    try {
        productList.value = [];
        loading.value = true;
        const res = await getProductList({ num: 0, size: 100 }, {
            orderField: currSort.value.field,
            orderSort: currSort.value.sort,
            colorLike: pcolor.value != 0 ? pconfig.value.colorList.filter(item => item.id == pcolor.value).map(item => item.label)[0] : null,
            sizeLike: psize.value != 0 ? pconfig.value.sizeList.filter(item => item.id == psize.value).map(item => item.label)[0] : null,
            priceLike: pprice.value != 0 ? pconfig.value.priceList.filter(item => item.id == pprice.value).map(item => item.label)[0] : null,
            categoryId: ptype.value
        });
        productList.value = res.data?.content.map(item => {
            return {
                "id": item.id,
                "spuName": item.name,
                "spuDesc": item.brandName,
                "coverImage": item.pic,
                "productDetailShow": item.salesVolume,
                "categoryName": item.productCategoryName,
                "retailPrice": item.price || 0,
            }
        })

        // 检查是否使用了降级数据
        // 如果API返回空数据，使用降级数据
        if (productList.value.length === 0) {
            productList.value = [];
        }
    } catch (error) {
        console.error('获取业务列表失败:', error);
        isFallback.value = true;
        errorMessage.value = '无法连接到服务器，显示备用数据';
        productList.value = [];
    } finally {
        loading.value = false;
    }
}


// 监听路由ID变化
watch( () => route.params.id,  (newId) => {
    console.log(newId)
    if (newId && newId !== ptype.value) {
        ptype.value = Number(newId || '0');
        loadConfig(newId)
        queryData();
    }
});

onMounted(async () => {
    ptype.value = Number(route.params.id || '0');
    loadConfig(ptype.value)
    queryData();
});

const topProductList = computed(() => productList.value);

const whichTime = time => {
    return moment(time).format("lll");
};

// 获取内容摘要
const getSummary = (content, length = 100) => {
    if (!content) return '暂无简介';

    // 移除HTML标签
    const plainText = content.replace(/<[^>]+>/g, '');

    if (plainText.length <= length) return plainText;
    return plainText.substring(0, length) + '...';
};



// 点击事件
const router = useRouter();
const handleChangepage = (id) => {
    router.push(`/product/${id}`);
};
</script>

<style lang="scss" scoped>
.boxs-page {

    .featured-type,
    .featured-mobile {
        width: 300px;
        padding: 10px;

        .title {
            font-weight: 500;
            font-size: 20px;
            color: #222222;
            line-height: 32px;
        }

        .type-product {
            width: 100%;

            :deep(.el-radio-group) {
                display: flex;
                flex-direction: column;
                align-items: start;
                justify-items: start;
            }

            :deep(.el-radio__inner) {
                width: 16px;
                height: 16px;

                &:after {
                    width: 6px;
                    height: 6px;
                }
            }

            :deep(.el-radio__label) {
                font-size: 16px !important;
            }
        }

        .type-color,
        .type-size {
            display: flex;
            flex-wrap: wrap;

            .icon-checkmark {
                display: none;

                &.is--selected {
                    display: inline-block;
                    color: #FFFFFF;
                    position: absolute;
                    top: 60%;
                    left: 50%;
                    right: unset;
                    -webkit-transform: translate3d(-50%, -50%, 0);
                    -ms-transform: translate3d(-50%, -50%, 0);
                    transform: translate3d(-50%, -50%, 0);
                }

            }


            .is--button {
                background: transparent;
                border: 0;
                padding: 0;
            }

            .is--color {
                width: 32%;
                height: 100%;
                min-height: 68px;
                text-align: center;
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-flex-direction: column;
                -ms-flex-direction: column;
                flex-direction: column;
                -webkit-align-items: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
            }

            .filter-item__color-patch {
                position: relative;
                width: 28px;
                height: 28px;
                text-align: center;
                border-radius: 14px;
                display: block;

                img {
                    border-radius: 14px;
                }
            }

            .filter-item__item-label {
                padding-top: 2px;
                font-size: 16px;
                display: inline-block;
                font: var(400 1rem/1.5 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '苹方-简', 'Heiti SC', '黑体-简', 'Microsoft YaHei', '微软雅黑', sans-serif);
                word-break: break-word;
                white-space: normal;

                &.is--selected {
                    color: var(--primary-color);
                }
            }
        }

        .type-size {
            display: flex;
            flex-wrap: wrap;

            .is--size {
                height: 36px;
                text-align: center;
                border: solid 1px #E5E5E5;
                border-radius: 5px;
                margin-right: 6px;
                margin-bottom: 6px;
                -webkit-flex: 1 0 56px;
                -ms-flex: 1 0 56px;
                flex: 1 0 56px;
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: center;
                -webkit-justify-content: center;
                -ms-flex-pack: center;
                justify-content: center;
                -webkit-align-items: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;

                &.is--selected {
                    border: solid 1px #000000;
                }
            }
        }
    }

    .featured-section {
        flex: 1;
        margin-bottom: 60px;

        .featured-card {
            background-color: #fff;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
            height: 100%;
            cursor: pointer;
            transition: transform 0.3s;

            &:hover {
                transform: translateY(-5px);
                box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);

                .card-image {
                    img {
                        transform: scale(1.1);
                    }
                }
            }

            .card-image {
                height: 200px;
                display: flex;
                flex-direction: columnr;
                align-items: center;
                justify-content: center;
                // background-size: cover;
                // background-position: center;
                position: relative;
                background-color: #F8F8F8;

                img {
                    height: auto;
                    width: 240px;
                    max-width: 100%;
                }

                .card-category {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    background-color: rgba(0, 0, 0, 0.6);
                    color: #fff;
                    padding: 4px 10px;
                    border-radius: 4px;
                    font-size: 12px;
                }
            }

            .card-content {
                padding: 20px;

                .card-title {
                    font-size: 16px;
                    font-weight: 600;
                    color: #111111;
                    margin-top: 0;
                    margin-bottom: 0px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    line-height: 1.5;
                }



                .card-meta {
                    color: #707072;
                    font-size: 16px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    line-height: 1.5;
                }

                .price {
                    padding-top: 10px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    font-size: 16px;
                    color: #222222;
                    font-style: normal;
                }
            }
        }
    }


}

.featured-mobile {
    display: none !important;
}


@media (max-width: 992px) {
    .featured-mobile {
        display: block !important;
    }

    .featured-type,
    .section-menu {
        display: none !important;

        :deep(.el-drawer__header) {
            margin-bottom: 0px;
        }
    }

}

.section-mobile {
    display: none;

    @media (max-width: 992px) {
        display: flex;
    }

    flex-direction: row;
    justify-content: space-between;
    align-items: end;

    .section-btn {
        cursor: pointer;
        padding: 9px 20px;
        height: auto;
        width: auto;
        transform: translate3d(0px, 0px, 0px);
        background: #111111;
        color: #FFFFFF;
        border-radius: 30px;
        text-align: center;
        text-decoration: none;
        box-sizing: border-box;
        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
        position: relative;
        overflow: hidden;
        border: none;
        outline: none;

        &:last-child {
            background-color: transparent;
            color: #000;
            border: 1px solid #CACACB;
        }

        &:hover {
            border: 1px solid #111111;
        }
    }

}

.section-header {
    text-align: center;
    margin-bottom: 20px;

    .el-menu--horizontal>.el-menu-item:nth-child(1) {
        margin-right: auto;
    }

    .el-menu-item {
        background-color: #FFFFFF !important;

        .is-active {
            border-bottom: 0px !important;
        }
    }

    .section-title {
        font-size: 28px;
        font-weight: 700;
        color: #333;
        position: relative;
        display: inline-block;
        margin: 0;

        // &::after {
        //     content: '';
        //     position: absolute;
        //     bottom: -10px;
        //     left: 50%;
        //     transform: translateX(-50%);
        //     width: 50px;
        //     height: 3px;
        //     background-color: #409EFF;
        // }
    }

    .section-desc {
        font-size: 16px;
        color: #666;
        max-width: 700px;
        margin: 20px auto 0;
    }
}

.page-container {
    max-width: 1500px;
    padding: 0 15px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
}
</style>